module.exports = __webpack_public_path__ + "static/media/BG_small.e8b1b7f9.webp";